import React from "react";
import { Navigate } from "react-router-dom";

// Dashboard
import Widgets from "../pages/Dashboard/Index";
// Authentication
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import ResetPasswordForm from "../pages/Authentication/ResetPassword.js";
import UserProfile from "../pages/Authentication/userProfile.js";
import PolicyUpload from "../pages/PolicyUpload";
import SettingsDashboard from "../pages/SettingsDashboard";

const authProtectedRoutes = [
  { path: "/dashboard", component: <Widgets /> },
  { path: "/policy-upload", component: <PolicyUpload /> },
  { path: "/settings-dashboard", component: <SettingsDashboard /> },
  { path: "/", exact: true, component: <Navigate to="/dashboard" /> },
  { path: "/profile", component: <UserProfile /> },
  { path: "*", component: <Navigate to="/login" /> },
];

const publicRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/reset-password", component: <ResetPasswordForm /> },
];

export { authProtectedRoutes, publicRoutes };
  